export default __webpack_public_path__ + "static/Kaminari_Mint_Machin_CROP-b91c4973281b086702018329383e7f6e.mp4";